import React from 'react';

export const MND_ASSETS_URL = window.env
  ? window.env.MND_ASSETS_URL
  : process.env.REACT_APP_MND_ASSETS_URL;

const CloudinayImage = ({ cloudinaryId, cropping, sizes, alt }) => {
  const croppingUrlParameters = cropping
    ? `/c_crop,h_${cropping.height},w_${cropping.width},x_${cropping.x},y_${
        cropping.y
      }`
    : '';

  const getUrl = width =>
    `${MND_ASSETS_URL}/image/upload/${croppingUrlParameters}/ar_16:9,c_fill,g_auto,w_${width}/${cloudinaryId}`;

  const srcset = [746, 1782]
    .map(width => `${getUrl(width)} ${width}w`)
    .join(', ');
  return <img srcSet={srcset} src={getUrl(746)} alt={alt} sizes={sizes} />;
};

export default CloudinayImage;
